import React, { memo, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Icon from "../../assets/icons/Icon";
import { Image, Input, Label } from "../";
import { uiActions } from "../../store/ui/ui-slice";
import { Link } from "react-router-dom";
import { logoutUser } from "../../store/user/user-action";

const TopBarOptions = ({ user }) => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { theme } = useSelector((state) => state.ui);

  // Initialize theme on component mount
  useEffect(() => {
    const root = document.documentElement;
    const storedTheme = theme || localStorage.getItem("theme") || "light";
    root.setAttribute("data-theme", storedTheme);
    
    // Sync with Redux if needed
    if (!theme) {
      dispatch(uiActions.setTheme(storedTheme));
    }
  }, []);

  // Sync theme changes with DOM
  useEffect(() => {
    if (theme) {
      const root = document.documentElement;
      root.setAttribute("data-theme", theme);
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  // Handle outside click to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    dispatch(uiActions.setTheme(newTheme));
  };

  const handleLogout = async () => {
    setIsOpen(false);
    await logoutUser(dispatch);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <header className="user_name_box user-id" ref={dropdownRef}>
      <button
        type="button"
        className="profile-inner-circle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="img_box">
          <Image src="/assets/images/user.png" alt="User Profile" />
        </div>
        <p className="m-0">
          {user?.userId} <Icon name="ChevronDown" />
        </p>
      </button>

      {isOpen && (
        <div className="profile-hover-main profile-open">
          <div className="drp-setting-cover">
            <div className="theme-cover_box">
              <p className="dropdown-search">Theme</p>
              <div className="theme-switcher">
                <Input
                  id="theme-checkbox"
                  type="checkbox"
                  className="checkbox form-check-input"
                  checked={theme === "light"}
                  onChange={handleTheme}
                  aria-label="Toggle theme"
                />
                <Label htmlFor="theme-checkbox" className="checkbox-label">
                  <span className="icon_box">
                    <Icon name="Sun" />
                  </span>
                  <span className="icon_box">
                    <Icon name="MoonStar" />
                  </span>
                  <span className="ball"></span>
                </Label>
              </div>
            </div>
          </div>

          <ul className="user-report">
            <li>
              <Link
                to="/live-market"
                className="user_report-tex border_profile"
                onClick={handleLinkClick}
              >
                <Icon name="Sparkles" />
                Rules
              </Link>
            </li>
            <li>
              <Link
                to="/change-password"
                className="user_report-tex border_profile"
                onClick={handleLinkClick}
              >
                <Icon name="Unlock" />
                Change Password
              </Link>
            </li>
            <li>
              <button 
                type="button"
                className="user_report-tex" 
                onClick={handleLogout}
              >
                <Icon name="LogOut" />
                Log Out
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default memo(TopBarOptions);